enum EnvPreprodEnum {
    CZ01P = "cz02p",
    SK01P = "sk02p"
}

export default EnvPreprodEnum;
